export const REFERAL_MEDIUMS_EMAIL_OR_PHONE = {label: 'Email or phone', _id: '507f1f77bcf86cd799439014'};
export const REFERAL_MEDIUMS_IN_PERSON = {label: 'In-person', _id: '507f1f77bcf86cd799439015'};
export const REFERAL_MEDIUMS_OTHER = {label: 'Other', _id: '507f1f77bcf86cd799439016'};
